'use client';

import { type IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import Label from '@/components/Label/Label';
import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import { RichText } from '@/components/richText/RichText';
import FormikStreetField from '@/components/streetInput/FormikStreetField';
import { hasContent } from '@/helper/RichText';
import type { FormTextStoryblok } from '@/types/component-types-sb';
import { type FieldProps, useFormikContext } from 'formik';
import { type FC } from 'react';

import type { FormValues } from '../../types';

interface IInputField extends Omit<FormTextStoryblok, 'id'>, FieldProps, IDefaultFormBuilderProps {}

const InputField: FC<IInputField> = ({
  field,
  id,
  label,
  placeholder,
  infoText,
  required,
  disabled,
  readOnly,
  cityField,
  postcodeField,
}) => {
  const { values } = useFormikContext<FormValues>();
  return (
    <FormikStreetField
      name={field.name}
      postcode={(values[postcodeField] as string) || ''}
      city={(values[cityField] as string) || ''}
      id={id}
      disabled={disabled}
      placeholder={placeholder}
      label={label && <Label text={label} />}
      required={required}
      readOnly={readOnly}
      endAdornment={
        hasContent(infoText) ? (
          <InfoIconModal>
            <RichText text={infoText} />
          </InfoIconModal>
        ) : undefined
      }
    />
  );
};

export default InputField;
